/**
 * Runtime-toggleable diagnostics for the endoscopy / MPEG video pipeline.
 *
 * Video playback failures (ffmpeg.wasm load, DICOM extraction, remux) tend to
 * reproduce only in deployed environments (CSP, asset serving, codec support),
 * so the useful trace can't be a build-time `DEV`-only log. Enable it at runtime
 * in any environment without spamming every viewer's console:
 *
 *   localStorage.setItem('debug:video', '1')    // persists across reloads
 *   // or append ?debugVideo to the URL
 *
 * Failure-path logging (console.error) is always on; only the verbose
 * breadcrumbs and ffmpeg's internal log stream go through `vlog`.
 */
function videoDebugEnabled() {
    try {
        return (localStorage.getItem('debug:video') === '1' ||
            new URLSearchParams(window.location.search).has('debugVideo'));
    }
    catch {
        return false;
    }
}
/** Verbose video-pipeline log, emitted only when video diagnostics are enabled. */
export function vlog(...args) {
    if (videoDebugEnabled())
        console.warn('[video]', ...args);
}
